<script lang="ts">
  import * as ContextMenu from '$lib/components/ui/context-menu';

  // The item list shown for a message/comment, shared by MessageBubble.svelte and
  // CommentItem.svelte -- both render this inside their own <ContextMenu.Content>, reached either
  // by right-click/long-press anywhere on the row, or by clicking the "..." button (which
  // synthesizes the same contextmenu event rather than opening a second, separately-maintained
  // menu -- see MessageBubble/CommentItem's openContextMenu()).
  const REACTION_EMOJI = ['👍', '❤️', '😂', '😮', '😢', '🙏'];

  export let reactions: { user_id: number; emoji: string }[];
  export let currentUserId: number;
  export let mine: boolean;
  export let pinned: boolean;
  export let onReply: () => void;
  export let onForward: () => void;
  export let onPin: () => void;
  export let onUnpin: () => void;
  export let onReact: (emoji: string) => void;
  export let onEdit: () => void;
  export let onRequestDelete: () => void;
  export let onLog: (() => void) | null = null;

  $: myReactionEmoji = new Set(reactions.filter((r) => r.user_id === currentUserId).map((r) => r.emoji));
</script>

<ContextMenu.Sub>
  <ContextMenu.SubTrigger class="gap-1.5"><i class="fa-regular fa-face-smile w-[18px] text-center"></i>React</ContextMenu.SubTrigger>
  <ContextMenu.SubContent side="bottom" align="start">
    <div class="flex gap-1 p-1">
      {#each REACTION_EMOJI as emoji}
        <button type="button" class="rounded p-1 text-lg hover:bg-muted {myReactionEmoji.has(emoji) ? 'bg-muted' : ''}" on:click={() => onReact(emoji)}>
          {emoji}
        </button>
      {/each}
    </div>
  </ContextMenu.SubContent>
</ContextMenu.Sub>
<ContextMenu.Item class="grid grid-cols-[18px,1fr] gap-1" on:click={onReply}><i class="fa-solid fa-reply justify-self-center"></i>Reply</ContextMenu.Item>
<ContextMenu.Item class="grid grid-cols-[18px,1fr] gap-1" on:click={onForward}><i class="fa-solid fa-share justify-self-center"></i>Forward</ContextMenu.Item>
{#if pinned}
  <ContextMenu.Item class="grid grid-cols-[18px,1fr] gap-1" on:click={onUnpin}><i class="fa-solid fa-thumbtack-slash justify-self-center"></i>Unpin</ContextMenu.Item>
{:else}
  <ContextMenu.Item class="grid grid-cols-[18px,1fr] gap-1" on:click={onPin}><i class="fa-solid fa-thumbtack justify-self-center"></i>Pin</ContextMenu.Item>
{/if}
{#if mine}
  <ContextMenu.Item class="grid grid-cols-[18px,1fr] gap-1" on:click={onEdit}><i class="fa-solid fa-pen justify-self-center"></i>Edit</ContextMenu.Item>
  <ContextMenu.Item class="grid grid-cols-[18px,1fr] gap-1" on:click={onRequestDelete}><i class="fa-solid fa-trash justify-self-center"></i>Delete</ContextMenu.Item>
{/if}
{#if onLog}
  <ContextMenu.Item class="grid grid-cols-[18px,1fr] gap-1" on:click={onLog}><i class="fa-solid fa-file-alt justify-self-center"></i>Log</ContextMenu.Item>
{/if}
